import { PopupPlacement, Tooltip } from "@gravity-ui/uikit";
import { PropsWithChildren } from "react";

interface IconTooltip {
  content: string;
  placement?: PopupPlacement;
}
export const IconTooltip = ({
  content,
  placement = "top",
  children,
}: PropsWithChildren<IconTooltip>) => {
  return (
    <Tooltip content={content} openDelay={200} placement={placement}>
      <span>{children}</span>
    </Tooltip>
  );
};
